import React from 'react';
import { ProgramRequestModalShell } from './ProgramRequestModalShell';

export const CreateProgramRequestModal = props => (
    <ProgramRequestModalShell {...props} mode="create" />
);

// Backward-compatible name for existing create-modal callers.
export const ProgramRequestModal = CreateProgramRequestModal;
